import { SCOPES, msalApp } from 'utils/AuthUtils';
/* project HTTP Client */


async function fetchWithCredentials(url, opts = {}, contentType) {
  let token;
  try {
    const account = msalApp.getAllAccounts()[0];
    token = await msalApp.acquireTokenSilent({account: account, ...SCOPES.LOGIN});
  } catch(e) {
    console.warn('token is expired, attempting re-login');
    msalApp.loginRedirect(SCOPES.LOGIN);
  };
  return fetch(
    url,
    Object.assign(opts, {
      credentials: 'same-origin',
      headers: {
        Authorization: `Bearer ${token.accessToken}`,
        ...contentType
    }
    }),
  );
}


/**
 * Custom Fetch implementation to include credentials by default, and any other headers in the above fetchWithCredentials function
 * @param {*} url 
 * @param {*} opts 
 */
function HttpClient(url, opts,contentType) {
  return Object.assign(fetchWithCredentials.bind(null, url, opts,contentType), fetch)();
}

export default HttpClient;